/* Regnum product-page share button.
   On click:
     - If the browser supports navigator.share (mobile + modern desktop),
       opens the OS-native share sheet (WhatsApp, Mail, Messages, etc).
     - Otherwise, toggles a small dropdown with WhatsApp / Copy link / Email.
   Copy link uses navigator.clipboard with a legacy execCommand fallback.
*/
(function () {
  'use strict';

  function init() {
    var btn = document.querySelector('.regnum-share-btn');
    if (!btn) return;
    var menu = document.querySelector('.regnum-share-menu');
    var copyBtn = menu && menu.querySelector('.regnum-share-copy');

    function getProductInfo() {
      var url = window.location.origin + window.location.pathname;
      var h1 = document.querySelector('h1');
      var title = (h1 && h1.textContent && h1.textContent.trim()) || document.title;
      return { url: url, title: title, text: title + ' — Regnum Supplies' };
    }

    function openMenu() {
      if (!menu) return;
      menu.removeAttribute('hidden');
      menu.setAttribute('data-open', '');
      btn.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      if (!menu) return;
      menu.setAttribute('hidden', '');
      menu.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function isMenuOpen() {
      return menu && menu.hasAttribute('data-open');
    }

    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();
      var info = getProductInfo();
      if (navigator.share) {
        try {
          await navigator.share({ title: info.title, text: info.text, url: info.url });
          return;
        } catch (err) {
          if (err && err.name === 'AbortError') return;
        }
      }
      if (isMenuOpen()) closeMenu(); else openMenu();
    });

    if (copyBtn) {
      var labelSpan = copyBtn.querySelector('span');
      var originalLabel = labelSpan ? labelSpan.textContent : 'Copy link';

      copyBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        var info = getProductInfo();
        var ok = false;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(info.url);
            ok = true;
          }
        } catch (err) {}
        if (!ok) {
          var ta = document.createElement('textarea');
          ta.value = info.url;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          try { ok = document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(ta);
        }
        if (ok && labelSpan) {
          labelSpan.textContent = 'Copied!';
          setTimeout(function () {
            labelSpan.textContent = originalLabel;
            closeMenu();
          }, 1200);
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!isMenuOpen()) return;
      if (btn.contains(e.target) || (menu && menu.contains(e.target))) return;
      closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isMenuOpen()) {
        closeMenu();
        btn.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 50); });
  } else {
    setTimeout(init, 50);
  }

  /* ----- Wishlist Hero proxy: customer clicks our custom heart in the icon
     actions row; we forward the click to WLH's hidden injected button so the
     item is saved/removed using WLH's own logic. Polls + observes since WLH
     injects async. ----- */
  function findWlhButton() {
    return document.querySelector(
      '.wishlist-hero-product-app-block button, ' +
      '#wishlisthero-product-page-button-container button, ' +
      '[id^="wishlisthero-product-page"] button'
    );
  }

  function wireWishlistProxy() {
    var ourHeart = document.querySelector('.regnum-icon-actions .wishlist-productpage > a');
    if (!ourHeart || ourHeart.dataset.regnumWired === 'true') return false;
    var wlhBtn = findWlhButton();
    if (!wlhBtn) return false;

    ourHeart.addEventListener('click', function (e) {
      e.preventDefault();
      var live = findWlhButton();
      if (live) live.click();
    });
    ourHeart.dataset.regnumWired = 'true';

    // Mirror the WLH "saved" state visually on our heart
    syncSavedState();
    return true;
  }

  function syncSavedState() {
    var wlhBtn = findWlhButton();
    var ourWrap = document.querySelector('.regnum-icon-actions .wishlist-productpage');
    if (!wlhBtn || !ourWrap) return;
    // WLH typically adds a class like 'wlh-added' or sets aria-pressed, or
    // swaps the icon. We detect "saved" by checking if button has 'added',
    // 'is-added', or 'wlh-added' anywhere in its classList, or if the icon's
    // fill attribute is set (filled heart vs outline).
    var saved = false;
    if (wlhBtn.className && /added|saved|active/i.test(wlhBtn.className)) saved = true;
    var icon = wlhBtn.querySelector('svg, i');
    if (icon && icon.getAttribute && /added|saved|filled/i.test(icon.getAttribute('class') || '')) saved = true;
    if (saved) {
      ourWrap.classList.add('is-saved');
    } else {
      ourWrap.classList.remove('is-saved');
    }
  }

  function startWishlistProxy() {
    if (wireWishlistProxy()) {
      attachWishlistObserver();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (wireWishlistProxy() || tries > 40) {
        clearInterval(timer);
        if (tries <= 40) attachWishlistObserver();
      }
    }, 200);
  }

  function attachWishlistObserver() {
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function () {
      syncSavedState();
    });
    var wlhBtn = findWlhButton();
    if (wlhBtn) {
      mo.observe(wlhBtn, { attributes: true, attributeFilter: ['class', 'aria-pressed'], childList: true, subtree: true });
    }
    setTimeout(function () { mo.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(startWishlistProxy, 100); });
  } else {
    setTimeout(startWishlistProxy, 100);
  }
})();
